import { HubListEntryKind, PersonType, hashFolderId } from '../../shared';
import type { Filter } from '../../appstate';
import type { PersonaListEntry, PersonaEntry } from '../selectors/personaListSelector';
import { toLoggingFilterName } from './personaListFilterUtils';

export interface PersonaListStatistics {
    folderId: string;
    filter: string;
    counts: { [type: string]: number };
}

/**
 * Returns a string describing the entry type in the persona list. Used for logging
 * @param entry The entry in the persona list
 */
function getPersonaListTypeName(entry: PersonaEntry): string {
    switch (entry.value.type) {
        case PersonType.Person:
            return 'Person';

        case PersonType.PrivateDistributionList:
            return 'PDL';

        case PersonType.FavoritePerson:
            return 'Favorite';

        case PersonType.FavoritePrivateDistributionList:
            return 'FavoritePrivateDistributionList';

        case PersonType.FavoriteUnifiedGroup:
            return 'FavoriteUnifiedGroup';

        default:
            return 'Unknown';
    }
}

/**
 * Returns statistics for the persona list: current filter and counts of the different entry types.
 * @param entries The entries in the persona list
 * @param filter The current filter for the persona list
 * @param folderId The folder id
 */
export function getPersonaListStatistics(
    entries: PersonaListEntry[],
    filter: Filter,
    folderId: string
): PersonaListStatistics {
    const stats: PersonaListStatistics = {
        folderId: hashFolderId(folderId),
        filter: toLoggingFilterName(filter),
        counts: {},
    };

    entries.forEach(entry => {
        if (entry.kind === HubListEntryKind.Content) {
            const type = getPersonaListTypeName(entry);
            stats.counts[type] = (stats.counts[type] || 0) + 1;
        }
    });

    return stats;
}
